<template>
  <div class="page-rule">
    <navigation>规则</navigation>
    <div class="rule-content">
      <div class="content-main">
        <p class="title">金融权益</p>
        <p class="info">（1）授信审核提速：会员在申请授信时可享受审核提速免排队特权，有效期内可享受1次特权；</p>
        <p class="info">（2）如用户在申请授信申请后、出来授信结果之前购买该卡，购买后即自动使用。</p>
        <p class="title">生活权益</p>
        <p class="info">（1）饿了么超级会员：五折购买价值15元的饿了么超级会员，有效期内可享受1次特权；</p>
        <p class="info">（2）话费充值抵扣券：充值30元以上可减3元，有效期内可享受1次特权；</p>
        <p class="info">（3）瑞幸咖啡26元券：5折购买价值26元的瑞幸咖啡券，有效期内可享受1次特权；</p>
        <p class="info">（4）好大夫在线问诊：好大夫在线免费问诊，有效期内可享受1次特权。</p>
        <p class="title">会员有效期</p>
        <p class="info">自购买日起30日内有效</p>
        <p class="title">退卡规则</p>
        <p class="info">该会员卡购买后，权益内容一经使用不可退卡</p>
      </div>
      <div class="content-tips">活动最终解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page-rule {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #27202E;
  .navigation{
    flex: 0 0 auto;
  }
  .rule-content{
    padding: 40px;
    background-color: #27202E;
    .content-main{
      background-color: #fff;
      border-radius: 30px;
      padding: 30px 25px 70px;
      .title{
        font-size: 32px;
        color: #333333;
        margin: 50px 0 10px;
        line-height: 45px;
        font-weight: bold;
      }
      .info{
        font-size: 26px;
        color: #666666;
        line-height: 37px;
      }
    }
    .content-tips{
      font-size: 26px;
      color: #706B75;
      text-align: center;
      margin-top: 60px;
    }
  }
}
</style>